// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608311834/js/" + chunkId + "." + {"44":"99651481","225":"4bc28d15","481":"7adfc1d7","486":"90db4910","770":"1edf9b51"}[chunkId] + ".0.7593831961671289.chunk.js";
};